import { render, staticRenderFns } from "./PlayAndJoinProject.vue?vue&type=template&id=bcd08c20&scoped=true&lang=pug&"
import script from "./PlayAndJoinProject.vue?vue&type=script&lang=js&"
export * from "./PlayAndJoinProject.vue?vue&type=script&lang=js&"
import style0 from "./PlayAndJoinProject.vue?vue&type=style&index=0&id=bcd08c20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd08c20",
  null
  
)

export default component.exports